import { render } from "./AccountEvents.vue?vue&type=template&id=2abd2183"
import script from "./AccountEvents.vue?vue&type=script&lang=js"
export * from "./AccountEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__